import http from './http';

export default {
  export(data) {
    return http().post(`/v1/exports/records`, data);
  }
}
